export enum DrawModeEnum {
    DEFAULT,
    START,
    END = 2,
    RESTART
}